import { get, size, some } from 'lodash/fp';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

// 180 characters is roughly 3 lines of text
const CHAR_LIMIT_DETERMINER = 180;

// @ts-expect-error - Automatic, Please fix when editing this file
const getHasSmallDetailsVariant = ({ steps }) =>
  some((step) => {
    const detailsStepText = portableTextToPlain(get('details', step));
    return size(detailsStepText) >= CHAR_LIMIT_DETERMINER;
  }, steps);

export default getHasSmallDetailsVariant;
